<div class="auth-wrapper auth-v2">
  <app-language-selector></app-language-selector>
  <div class="auth-inner max-width row m-0">
    <div class="d-flex align-items-center p-5 l-side">
      <div
        class="w-100 d-lg-flex align-items-center justify-content-center px-5"
      >
        <img
          class="img-fluid"
          [src]="isMobile() | authHeroImage"
          alt="Login Picture"
        />
      </div>
    </div>
    <!-- Set Company-->
    <div class="d-flex align-items-center auth-bg r-side">
      <div class="mx-auto login-form">
        <div class="company-logo">
          <img [src]="'assets/images/logo/logo-blue-2.svg'" alt="" />
        </div>
        <h2 class="card-title mb-1">
          {{ 'COMPANY_LOGIN.FORM_HEADER' | translate }} 👋
        </h2>
        <p class="card-text mb-2">{{ 'COMPANY_LOGIN.FORM_SUBHEADER' | translate }}</p>

        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
          <div class="alert-body">
            <p>{{ error }}</p>
          </div>
        </ngb-alert>

        <form
          class="auth-login-form mt-2"
          [formGroup]="companyLoginForm"
          (ngSubmit)="setCompany()"
        >
          <div class="form-group">
            <label class="form-label">{{
              'COMPANY_LOGIN.COMPANY_LABEL' | translate
            }}</label>
            <input
              type="text"
              tabindex="1"
              id="login-input"
              formControlName="subdomain"
              class="form-control"
              [placeholder]="'COMPANY_LOGIN.COMPANY_PLACEHOLDER' | translate"
              [ngClass]="{
                'is-invalid':
                  f?.subdomain.errors &&
                  (f?.subdomain.dirty || f?.subdomain.touched)
              }"
            />
            <div
              *ngIf="
                f?.subdomain.errors &&
                (f?.subdomain.dirty || f?.subdomain.touched)
              "
              class="invalid-feedback"
            >
              <div *ngIf="f?.subdomain.errors.required">
                {{ 'COMPANY_LOGIN.COMPANY_REQUIRED' | translate }}
              </div>
            </div>
            <p class="company-code-info">
              <span class="icon-info feather ficon"></span>
                {{'COMPANY_LOGIN.COMPANY_INFO' | translate}}
            </p>
          </div>
          <button
            [disabled]="companyLoginForm.invalid"
            class="btn btn-primary btn-block"
            tabindex="4"
            rippleEffect
          >
            {{ 'COMPANY_LOGIN.CONTINUE_BUTTON' | translate }}
          </button>
        </form>
      </div>
    </div>
    <!-- /Set Company-->
  </div>
</div>
